export default __webpack_public_path__ + "static/media/employeeimg.a17ee444.png";